import '@/types';
import notificationService from '@/services/notificationService';
import subcontractorsRepository from '@/services/subcontractorsRepository';

export default class Subcontractor implements ISubcontractor {
    public pricingAgreements: IPricingAgreement[] | null = [];
    public id?: string;
    public logs: ILog[] = [];
    public companyName: string = '';
    public vatNumber?: string = '';
    public lastname?: string;
    public email?: string;
    public phone?: string;
    public language?: string;
    public termsOfPayment: number | null = null;
    public contactIds: string[] = [];
    public tags: string[] = [];
    public notes?: string;
    public readonly displayName: string = '';
    public addresses: IAddress[] = [];
    public teams: ISubcontractorTeam[] = [];
    public labourAgreements: ISubcontractorLabourAgreement[] = [];
    public specialty?: string;
    public type: string = 'Subcontractor';
    public tunnelGroupsId?: string;
    public tunnelGroups?: string;

    public loading: boolean = false;
    public saving: boolean = false;

    public async loadData(id: string) {
        try {
            this.loading = true;
            const result = await subcontractorsRepository.getSingle(id);
            Object.assign(this, result.data);
            if (!this.teams) {
                this.teams = [];
            }
        } catch {
            notificationService.failedToLoad();
        } finally {
            this.loading = false;
        }
    }

    public async save() {
        let saved = false;
        try {
            this.saving = true;
            if (this.id) {
                const result = await subcontractorsRepository.update(this);
                Object.assign(this, result.data);
                if (!this.teams) {
                    this.teams = [];
                }
            } else {
                const result = await subcontractorsRepository.create(this);
                Object.assign(this, result.data);
                if (!this.teams) {
                    this.teams = [];
                }
            }
            saved = true;
            notificationService.saved();
        } catch {
            notificationService.failedToLoad();
        } finally {
            this.saving = false;
        }

        return saved;
    }

    public async addOrUpdateAddress(address: IAddress, index: number = -1) {
        try {
            if (index === -1) {
                this.addresses.push(address);
            } else {
                this.addresses[index] = address;
            }
            await this.save();
            return true;
        } catch {
            notificationService.failedToSave();
            return false;
        }
    }

    public async deleteAddress(index: number) {
        this.addresses.splice(index, 1);
        await this.save();
    }

    public async addOrUpdateTeam(team: ISubcontractorTeam, index: number = -1) {
        try {
            if (index === -1) {
                this.teams.push(team);
            } else {
                this.teams[index] = team;
            }
            await this.save();
            return true;
        } catch {
            notificationService.failedToSave();
            return false;
        }
    }

    public async deleteTeam(index: number) {
        this.teams.splice(index, 1);
        await this.save();
    }
}
